import React, { FC, useRef, useCallback, useEffect, useMemo } from "react"
import { useRequest } from "ahooks"
import { getPoi } from "@/api/park"
import { useSetState } from "@/reactUse"
import Env from "@util/env"
type TProps = { visible: boolean; map: any; store: any }
const LayerPoi: FC<TProps> = ({ visible, map, store }) => {
  const { data } = useRequest(getPoi, {})
  const [hide, setHide] = useSetState<any>({
    产业分布: true,
    医院综合: true,
    中小学校: true,
    科研院校: true,
  })
  const ref = useRef<any>()
  const refCache = useRef<any>({})
  const clear = useCallback(() => {
    if (ref.current) {
      ref.current.forEach((m) => {
        m.setMap(null)
      })
      ref.current = null
    }
  }, [ref])
  const cates = useMemo(() => {
    return [
      { name: "产业分布", color: "rgba(24, 144, 255, 0.9)" },
      { name: "医院综合", color: "rgba(255, 248, 0, 0.9)" },
      { name: "中小学校", color: "rgba(0, 255, 25, 0.9)" },
      { name: "科研院校", color: "rgba(142, 108, 255, 1)" },
    ]
  }, [])
  const normalMarker = useMemo(() => {
    const AMap = window.AMap
    return new AMap.Marker({
      offset: new AMap.Pixel(0, -50 * Env.getScale()),
    })
  }, [])
  const onMouseOver = useCallback(
    (e) => {
      let poi = e.target.getExtData()
      if (!poi || !poi.coord) return
      normalMarker.setContent(
        '<div class="amap-info-window">' +
          poi.name +
          '<div class="amap-info-sharp"></div>' +
          "</div>"
      )
      normalMarker.setPosition(poi.coord)
      map.add(normalMarker)
    },
    [normalMarker, map]
  )
  const onMouseOut = useCallback(() => {
    map.remove(normalMarker)
  }, [normalMarker, map])
  useEffect(() => {
    if (!visible) {
      clear()
    } else if (map) {
      // clear()
      const AMap = window.AMap
      if (!data) return
      let markers = (ref.current = [])

      cates.forEach((cate) => {
        let { name, color } = cate
        if (!refCache.current[name]) {
          if (!data[name]) return
          refCache.current[name] = data[name].map((poi) => {
            var circleMarker = new AMap.CircleMarker({
              center: poi.coord,
              fillColor: color,
              strokeColor: color,
              radius: 3 * Env.getScale(), //px
              strokeWeight: 0,
              extData: {
                name: poi.name,
                coord: poi.coord,
              },
            })
            circleMarker.setMap(map)
            circleMarker.on("mouseover", onMouseOver)
            circleMarker.on("mouseout", onMouseOut)
            markers.push(circleMarker)
            return circleMarker
          })
        }
        if (!hide[name]) {
          refCache.current[name].forEach((marker) => {
            marker.setMap(map)
          })
        } else {
          refCache.current[name].forEach((marker) => {
            marker.setMap(null)
          })
        }
      })
    }
    return () => {
      clear()
    }
  }, [map, visible, clear, ref, data, hide, cates, onMouseOver, onMouseOut])

  return (
    <div className="layer-poi">
      {cates.map((cate, i) => {
        let { name, color } = cate
        let c = color
        if (hide[name]) {
          c = "grey"
        }
        return (
          <div
            className="it-cate"
            key={i}
            onClick={() => {
              if (name === "产业分布") {
                store.toogleIndustry(hide[name])
              }
              setHide({ [name]: !hide[name] })
            }}
          >
            <span className="flag-active" style={{ background: c }}></span>
            <span className="name">{name}</span>
          </div>
        )
      })}
    </div>
  )
}
export default LayerPoi
